export enum ConfigElementComponentType {
    Custom,
    String,
    Text,
    Textarea,
    Checkbox,
    Dropdown,
    ColorPicker,
    QuantityPicker,
    Datatable,
    Select,
    ObjectSelect,
}
